var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/prod";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN;

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 1,
    hideSourceMaps: true,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    integrations: [new Sentry.Replay()],

    ignoreErrors: [
      // Temporarily add ignore error messages to reduce Quotas.
      '/._cacheContext./',
      '/i.scale/',
      '/t.clearRect/',
      // Message when develop debug in user' design
      '/Request failed with status code 422/',
      // e.parentElement when click next step tour guide in Iphone: https://acworks-sr.sentry.io/issues/4069041781/tags/user/?project=4504647887945728&query=error.unhandled%3Atrue+is%3Aunresolved&referrer=issue-stream&sort=user&statsPeriod=14d&stream_index=0
      '/e.parentElement/',
      // getBoundingClientRect: 19k event:https://acworks-sr.sentry.io/issues/4072146174/events/?project=4504647887945728&referrer=issue-stream&statsPeriod=7d&stream_index=13
      '/getBoundingClientRect/',
    ],
    beforeSend(event) {
      const userAgent = event?.request?.headers['user-agent'];
      if (userAgent?.includes('Firefox')) {
        return null; // ignore event from firefox
      }
      return event;
    },
  });
}
